// @ts-nocheck

import React from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import SimpleSpinner from '../SimpleSpinner';

const StyledButton = styled.div`
  border-radius: 1.3em;
  border: none;
  height: 2.5em;
  padding: 0 1em;
  user-select: none;
  transition: all 150ms ease-in-out;
  background: ${({ $isSelected, $backgroundColor, $selectedBackgroundColor }) =>
    $isSelected ? $selectedBackgroundColor : $backgroundColor};
  ${({ $isSelected, $borderColor, $selectedBorderColor }) => {
    if ((!$isSelected && $borderColor) || ($isSelected && $selectedBorderColor)) {
      const color = $isSelected ? $selectedBorderColor : $borderColor;
      return css`
        border: 1px solid ${color};
      `;
    }
  }}

  font-weight: 800;
  box-shadow: 0 0.3em 0.5em 0 rgba(0, 0, 0, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          filter: brightness(1.05);
        }
      `
    : undefined}

  &:active {
    transform: scale(0.95);
  }

  ${({ $disabled }) => {
    if ($disabled) {
      return css`
        filter: brightness(0.5);
        pointer-events: none;
      `;
    }
  }}

  ${({ $isLoading }) => {
    if ($isLoading) {
      return css`
        pointer-events: none;
        color: transparent;
      `;
    }
  }}
`;

const Center = styled.span`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Label = styled.span`
  color: ${({ $isLoading, $isSelected, $selectedColor, $color }) => {
    return $isLoading ? 'transparent' : $isSelected ? $selectedColor : $color;
  }};
`;

type Props = {
  className?: string;
  id?: string;
  label?: string;
  isSelected?: boolean;
  color: string;
  selectedColor?: string;
  backgroundColor?: string;
  borderColor?: string;
  selectedBorderColor?: string;
  selectedBackgroundColor?: string;
  disabled?: boolean;
  onClick: (e) => void;
};

const RoundedButton = forwardRef(function RoundedButton(
  {
    className,
    id,
    label,
    onClick,
    isSelected = false,
    color,
    selectedColor,
    backgroundColor,
    borderColor,
    selectedBorderColor,
    selectedBackgroundColor,
    disabled,
    isLoading,
  }: Props,
  ref,
) {
  return (
    <StyledButton
      className={className}
      id={id}
      ref={ref}
      onClick={!disabled ? onClick : null}
      $disabled={disabled}
      $backgroundColor={backgroundColor}
      $selectedBackgroundColor={selectedBackgroundColor}
      $isSelected={isSelected}
      $borderColor={borderColor}
      $selectedBorderColor={selectedBorderColor}
      $isLoading={isLoading}
    >
      <Center>
        <Label $isLoading={isLoading} $color={color} $selectedColor={selectedColor} $isSelected={isSelected}>
          {label}
        </Label>
        {isLoading ? <SimpleSpinner /> : null}
      </Center>
    </StyledButton>
  );
});

export default React.memo(RoundedButton);
